import {
    getAssetsDomain,
} from '~spa/SpectateConfig';

__webpack_public_path__ = `${getAssetsDomain()}${__webpack_public_path__}`; //eslint-disable-line
